
import Hero from './components/Hero';
import ComoFunciona from './components/ComoFunciona';
import Caracteristicas from './components/Caracteristicas';
import CasosUso from './components/CasosUso';
import EscuchaAgentes from './components/EscuchaAgentes';
import Testimonios from './components/Testimonios';
import CalendarSection from './components/CalendarSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0a0e27]">
      <Hero />
      <ComoFunciona />
      <Caracteristicas />
      <CasosUso />
      <EscuchaAgentes />
      <Testimonios />
      <CalendarSection />
      <Footer />
    </div>
  );
}
